@use '@/styles/tokens' as *;

.card {
  background: transparent;
  height: 100%;
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  //TODO: Uncomment this when we total is needed at the bottom of the card
  // justify-content: space-between;
}
.title {
  margin: 0 0 var(--space-5);
  font-size: 20px;
  font-weight: 500;
  color: $color-neutral-950;
}
.items {
  list-style: none;
  margin: 0 0 var(--space-6);
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
.item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-4);
}
.thumb {
  flex: 0 0 auto;
  width: 70px;
  height: 70px;
  border-radius: 12px;
  background: $color-neutral-100;
  object-fit: cover;
}
.info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}
.name {
  @include truncate;
  max-width: 100%;
  font-size: 14px;
  color: $color-neutral-950;
}
.sub {
  @include truncate(2);
  // One unbroken device name would otherwise run past the card instead of wrapping into the clamp.
  overflow-wrap: anywhere;
  font-size: 12px;
  color: $color-neutral-600;
}
.replaced {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 11px;
  color: $color-neutral-950;
}
// Figma `622:343262` — the row holding Add Parameter Template and the blue View Installation link.
// `.info` already stacks with `gap: var(--space-1)` (4px); the extra 8px brings the name→links
// distance to 12px against Figma's 14px, the nearest pair of spacing tokens. The `gap` is Figma's
// 27px between the two links rounded to the 24px token.
.links {
  display: flex;
  gap: var(--space-6);
  margin-top: var(--space-2);
}

// Figma `622:343265` / `622:343267` — both links are Geist Regular 11px. `<TextButton>`'s tone
// supplies the colour (`brand` = $color-brand-600 = #68B631, exact; `info` = the link blue) and
// `size="sm"` the closest shipped size (13px), so only size and weight are overridden. 11px is raw
// because the generated scale has no 11px step — the same reason `.replaced` above and
// `FormField .error` write it raw.
.link {
  font-size: 11px;
  font-weight: var(--font-weight-regular);
}

.prices {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--space-1);
}
.price {
  font-size: 14px;
  color: $color-neutral-950;
}
.each {
  font-size: 11px;
  color: $color-neutral-600;
}
.installation {
  font-size: 12px;
  color: $color-neutral-600;
}
.totals {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-top: var(--space-4);
}
.totalRow {
  display: flex;
  justify-content: space-between;
}
.totalRow dt {
  font-size: 14px;
  color: $color-neutral-700;
  margin: 0;
}
.totalRow dd {
  font-size: 14px;
  color: $color-neutral-950;
  margin: 0;
}
.grandTotal {
  border-top: 1px solid $color-neutral-200;
  padding-top: var(--space-3);
}
.grandTotal dt,
.grandTotal dd {
  font-size: 18px;
  font-weight: 600;
}
